import { render, staticRenderFns } from "./OfferPage.vue?vue&type=template&id=154f93ce&scoped=true"
import script from "./OfferPage.vue?vue&type=script&lang=ts"
export * from "./OfferPage.vue?vue&type=script&lang=ts"
import style0 from "./OfferPage.vue?vue&type=style&index=0&id=154f93ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154f93ce",
  null
  
)

export default component.exports